import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './LessonLabel.scss';

/**
 * Play Lesson Action Container
 */
const defaultProps = {
  label: '',
  className: '',
};
export default function LessonLabel(props) {
  const { label, className } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className={`leson-label ${className}`}>
      {label}
    </div>
  );
}
